import { Component } from '@angular/core';
import { EmployeeDashboardService } from '../../services/employee-dashboard.service';
import { AttendanceService } from 'src/app/modules/attendance/attendance.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { customJwtDecode as jwtDecode } from 'src/app/shared/helpers/custom-jwt';

@Component({
  selector: 'app-my-team',
  templateUrl: './my-team.component.html',
  styleUrls: ['./my-team.component.css'],
  standalone: false
})
export class MyTeamComponent {

  team: any[] = [];
  empDataFromParent: any;
  decoded_token: any;
  tp_account_id: any;
  product_type: any;
  p: any = 1;
  limit: any = 2000;
  attendanceDetails_data: any = [];
  upcomingLeaves: any = [];

  constructor(
    private dashboardService: EmployeeDashboardService,
    private _attendanceService: AttendanceService,
    private _sessionService: SessionService,
  ) { }

  ngOnInit(): void {
    // this.http.get<any[]>('/api/team')
    //   .subscribe(res => this.team = res);
    let session_obj = this._sessionService.get_user_session();
    let token = JSON.parse(session_obj).token;
    this.decoded_token = jwtDecode(token);

    this.tp_account_id = this.decoded_token.tp_account_id;
    this.product_type = localStorage.getItem('product_type');

    this.empDataFromParent = JSON.parse(localStorage.getItem('empDataFromParent'));
    // console.log('empDataFromParent in my-team:', this.empDataFromParent);
    this.get_today_attendence_reports();
  }

  markAbsent(id: number) {
    // this.http.post(`/api/team/${id}/absent`, {})
    //   .subscribe(() => {
    //     this.dashboardService.increment('attendance');
    //   });
  }

  get_today_attendence_reports() {
    let date = new Date();
    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    let year = date.getFullYear();
    let today_date = day + '/' + month + '/' + year;

    this._attendanceService
      .get_today_attendence_reports({
        action: 'get_today_attendence_reports_rm',
        accountId: (this.tp_account_id),
        geo_location_id: this.decoded_token.geo_location_id,
        productTypeId: this.product_type,
        // att_date: this.today_date,
        att_date: today_date,
        ouIds: '',
        keyword: '',
        status: '',
        emp_code: this.decoded_token.emp_code,
        pageindex: this.p - 1,
        pagesize: this.limit
      })
      .subscribe((resData: any) => {
        if (resData.statusCode) {
          this.attendanceDetails_data = resData.commonData;
          // console.log('attendanceDetails_data', this.attendanceDetails_data);

        } else {
          this.attendanceDetails_data = [];
        }
      });
  }


}
